import "babel-polyfill"
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../public/common.css'
import App from './App.vue'
import SlideVerify from '../node_modules/vue-monoplasty-slide-verify'
Vue.config.productionTip = false
import router from './router'
import store from './store'
Vue.use(SlideVerify)
Vue.use(ElementUI)

Vue.config.productionTip = false;

//全局方法 element 校验表单
Vue.prototype.$formRulesValidate = ({ ref, example }) => {
  return new Promise((res) => {
    example.$refs[ref].validate((valid)=>{
      res(valid);
    });
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
